import React from 'react';

function MobileHeader({ title, userRole, toggleMenu }) {
  // Format the role for better display
  const formatRole = (role) => {
    if (!role) return "Usuario";
    
    switch (role) {
      case 'Admin':
        return 'Administrador';
      case 'Supervisor':
        return 'Supervisor';
      case 'Monitoreo':
        return 'Monitoreo';
      case 'CA':
        return 'Controlador';
      case 'Auditor':
        return 'Auditor';
      case 'Financiero':
        return 'Financiero';
      case 'Recaudador':
        return 'Recaudador';
      default:
        return role;
    }
  };

  return (
    <div className="bg-blue-800 text-white shadow px-4 py-3 flex items-center justify-between md:hidden fixed top-0 left-0 right-0 z-10 transition-all duration-300 ease-in-out">
      <button
        onClick={toggleMenu}
        className="text-white p-1 focus:outline-none focus:ring-2 focus:ring-blue-300 rounded transition-all duration-300"
        aria-label="Menu"
      >
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      <h1 className="text-lg font-bold text-white transition-all duration-300">{title}</h1>
      <div className="text-right">
        {/* Only show role, no email */}
        <p className="text-sm font-medium text-white">
          {formatRole(userRole)}
        </p>
      </div>
    </div>
  );
}

export default MobileHeader;
